import React from 'react'
import { CFooter } from '@coreui/react'

const TheFooter = () => {
  return (
    <CFooter fixed={false}>
      <div>
        <span className="ml-1">&copy; Version 4.0</span>
      </div>
      <div className="mfs-auto">
        <span className="mr-1">Powered by</span>
        <a href="http://efwsolutions.com" target="_blank" rel="noopener noreferrer">EFW Engineering and Systems</a>
      </div>
    </CFooter>
  )
}

export default React.memo(TheFooter)
